import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IBackfillTranslationsRequest } from './backfill-translations-request';
import type { IBackfillTranslationsResponse } from './backfill-translations-response';
import { backfillTranslationsResponseSchema } from './backfill-translations-response';

export async function backfillTranslationsApi(
  body: IBackfillTranslationsRequest = {},
  options?: IRequestOptions,
): Promise<IValidatedResponse<IBackfillTranslationsResponse>> {
  return postRequest<IBackfillTranslationsResponse>({
    path: '/sys/challenges/backfill-translations',
    body,
    schema: backfillTranslationsResponseSchema,
    options,
  });
}
